import React, { useMemo, useState } from "react";
import { Armchair, BaggageClaim } from "lucide-react";
import { format } from "date-fns";
import CurFt from "../../components/CurFt";
// Single-file React component (Tailwind CSS required in the project)
// Uses lucide-react for icons. Action button color is your default: #f4a406
import {
  ArrowUpDown,
  Ticket,
  TicketCheck,
  TicketX,
  Utensils,
  Gift,
} from "lucide-react";
import Filters from "./Filters";

function parseTimeToMinutes(t) {
  // "20:15" -> 1215
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
}
function parseDurationToMinutes(d) {
  // "5h 25m" -> 325
  const [h, m] = d.replace("m", "").split("h").map((x) => x.trim());
  return Number(h || 0) * 60 + Number((m || "0").replace("m", "").trim() || 0);
}


export default function RoundInternationalResults(props) {
  const {
    outbound,
    FormData,
    handleBookNow,
    handlFlightDeatils,
    FiltStop,
    FiltPrice,
    FiltAirline,
    handleChangeStops,
    applyFilters,
    handleChangeAirlines,
    priceRangeFilter,
    PriceRange,
    selectedDeparture,
    selectedArrival,
    handleChangeDeparture,
    setSelectedDeparture,
    handleChangeArrival,
    setSelectedArrival,
    handleChangeFarepol,
    selectedFarepol,
    FiltFareClassOutbound,
    handleFareClassOutbound,
  } = props

  const [sortKey, setSortKey] = useState("price");
  const [sortDir, setSortDir] = useState("asc"); // 'asc' | 'desc'
  const sorted = useMemo(() => {
    const arr = [...outbound];
    arr.sort((a, b) => {
      const dir = sortDir === "asc" ? 1 : -1;
      switch (sortKey) {
        case "airline":
          return a.org.AirlineName.localeCompare(b.org.AirlineName) * dir;
        case "departure":
          return (parseTimeToMinutes(format(new Date(a.org.FromUTCTime), "HH:mm")) -
            parseTimeToMinutes(format(new Date(b.org.FromUTCTime), "HH:mm"))) * dir;
        case "duration":
          return (parseDurationToMinutes(a.org.Duration) -
            parseDurationToMinutes(b.org.Duration)) * dir;
        case "arrival":
          return (parseTimeToMinutes(format(new Date(a.org.ToUTCTime), "HH:mm")) -
            parseTimeToMinutes(format(new Date(b.org.ToUTCTime), "HH:mm"))) * dir;
        case "price":
        default:
          return (a.PubFare - b.PubFare) * dir;
      }
    });
    return arr;
  }, [outbound, sortKey, sortDir]);

  const handleSort = (key) => {
    if (key === sortKey) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortKey(key);
      setSortDir("asc");
    }
  };

  const [openIndex, setOpenIndex] = useState(null);
  const [openEye, setOpenEye] = useState(false);
  const toggleOpen = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <>
      <div className="flex flex-col md:flex-row gap-4 p-4">
        {/* Sidebar filter */}
        <Filters
          openEye={openEye}
          data={outbound}
          FormData={FormData}
          FiltStop={FiltStop}
          FiltPrice={FiltPrice}
          FiltAirline={FiltAirline}
          handleChangeStops={handleChangeStops}
          applyFilters={applyFilters}
          handleChangeAirlines={handleChangeAirlines}
          priceRangeFilter={priceRangeFilter}
          PriceRange={PriceRange}
          selectedDeparture={selectedDeparture}
          selectedArrival={selectedArrival}
          handleChangeDeparture={handleChangeDeparture}
          setSelectedDeparture={setSelectedDeparture}
          handleChangeArrival={handleChangeArrival}
          setSelectedArrival={setSelectedArrival}
          handleChangeFarepol={handleChangeFarepol}
          selectedFarepol={selectedFarepol}
          FiltFareClassOutbound={FiltFareClassOutbound}
          handleFareClassOutbound={handleFareClassOutbound}
        />

        {/* Main content */}
        <main className="w-full md:w-3/4 space-y-4">
          <div className="hidden md:grid grid-cols-12 px-4 py-2 text-sm font-semibold text-gray-700">
            <SortHead title="Airline" onClick={() => handleSort("airline")} active={sortKey === "airline"} dir={sortDir} className="col-span-4" />
            <SortHead title="Departure" onClick={() => handleSort("departure")} active={sortKey === "departure"} dir={sortDir} className="col-span-2" />
            <SortHead title="Duration" onClick={() => handleSort("duration")} active={sortKey === "duration"} dir={sortDir} className="col-span-2" />
            <SortHead title="Arrival" onClick={() => handleSort("arrival")} active={sortKey === "arrival"} dir={sortDir} className="col-span-2" />
            <SortHead title="Price" onClick={() => handleSort("price")} active={sortKey === "price"} dir={sortDir} className="col-span-2 justify-end pr-2" />
          </div>
          <div className="max-w-6xl mx-auto">
            {/* Header */}
            {/* <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4">
              <h2 className="text-2xl font-semibold">Delhi - Dubai - Delhi</h2>

              <div className="flex items-center gap-3 ml-auto">
                <div className="flex items-center gap-2 bg-white border rounded-md px-2 py-1 shadow-sm">
                  <span className="text-sm text-gray-600">Sort By:</span>
                  <button className="flex items-center gap-2 px-3 py-1 rounded-md bg-green-50 text-green-700 text-sm border border-green-100">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h3m10 0h3a1 1 0 011 1v16a1 1 0 01-1 1h-3m-10 0H4a1 1 0 01-1-1V4z" /></svg>
                    <span className="font-semibold">CHEAPEST</span>
                  </button>
                  <button className="px-3 py-1 rounded-md border text-sm">FASTEST</button>
                </div>

                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-600 mr-2">RECOMMENDED</span>
                  <label className="inline-flex relative items-center cursor-pointer">
                    <input type="checkbox" className="sr-only peer" checked={recommendedOn} onChange={() => setRecommendedOn(!recommendedOn)} />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-blue-500"></div>
                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full peer-checked:translate-x-5 transition-transform shadow-sm"></div>
                  </label>
                </div>
              </div>
            </div> */}


            {/* Results list */}
            <div className="space-y-6">
              {sorted.length > 0 && sorted?.map((r) => (
                <div key={r.keyIndex} className="bg-white border rounded-xl shadow-sm overflow-hidden">
                  <div className="p-2 grid grid-cols-1 md:grid-cols-12 gap-4 items-start">
                    {/* Flight details */}
                    <div className="md:col-span-10 grid grid-cols-1 md:grid-cols-2 gap-2">
                      {/* Outbound */}
                      <div className="flex flex-col bg-white rounded-lg border p-2">
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center p-1">
                              <img src={r?.org?.logo} alt={r?.org?.AirlineName} className="object-contain rounded-md w-full h-full" />
                            </div>
                            <div>
                              <div className="font-semibold text-lg">{r.org.AirlineName} <span className="text-gray-400">({r.org.FlightNumber})</span></div>
                            </div>
                          </div>
                          <div className="px-2 py-1 text-xs rounded-md bg-amber-50 text-amber-700 font-semibold">DEPARTURE</div>
                        </div>

                        <div className="flex items-center justify-between">
                          <div className="flex-1">
                            <div className="text-2xl font-bold">{format(new Date(r.org.FromUTCTime), "HH:mm")}</div>
                            <div className="text-sm text-gray-600">{r.org.SoCity}</div>
                            <div className="text-xs text-gray-400 mt-2">{format(new Date(r.org.FromUTCTime), "EEE-ddMMMyyyy")}</div>
                          </div>

                          <div className="flex-1 text-center">
                            <div className="text-sm "><span className="text-black"></span>{r.org.Duration} | <span className="text-gray-500" style={{ fontSize: '11px' }}>{r.org.StopCount}</span></div>
                            <div className="mt-2 text-xs text-blue-500 font-medium">{r.org.SoCode}-{r.org.DeCode}</div>
                            {/* <div className="mt-2 text-sm text-red-500" style={{ fontSize: '12px' }}>{r.FareList[0].SeatLeft} Seats Left</div> */}
                          </div>

                          <div className="flex-1 text-right">
                            <div className="text-2xl font-bold">{format(new Date(r.org.ToUTCTime), "HH:mm")}</div>
                            <div className="text-sm text-gray-600">{r.org.DeCity}</div>
                            <div className="text-xs text-gray-400 mt-2">{format(new Date(r.org.ToUTCTime), "EEE-ddMMMyyyy")}</div>
                          </div>
                        </div>
                      </div>

                      {/* Inbound */}
                      <div className="flex flex-col bg-white rounded-lg border p-2">
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center p-1">
                              <img src={r.des.logo} alt={r.des.AirlineName} className="object-contain rounded-md w-full h-full" />
                            </div>
                            <div>
                              <div className="font-semibold text-lg">{r.des.AirlineName} <span className="text-gray-400">({r.des.FlightNumber})</span></div>
                            </div>
                          </div>
                          <div className="px-2 py-1 text-xs rounded-md bg-amber-50 text-amber-700 font-semibold">RETURN</div>
                        </div>

                        <div className="flex items-center justify-between">
                          <div className="flex-1">
                            <div className="text-2xl font-bold">{format(new Date(r.des.FromUTCTime), "HH:mm")}</div>
                            <div className="text-sm text-gray-600">{r.des.SoCity}</div>
                            <div className="text-xs text-gray-400 mt-2">{format(new Date(r.des.FromUTCTime), "EEE-ddMMMyyyy")}</div>
                          </div>

                          <div className="flex-1 text-center">
                            <div className="text-sm "><span className="text-black"></span>{r.des.Duration} | <span className="text-gray-500" style={{ fontSize: '11px' }}>{r.des.StopCount}</span></div>
                            <div className="mt-2 text-xs text-blue-500 font-medium">{r.des.SoCode}-{r.des.DeCode}</div>
                            {/* <div className="mt-2 text-sm text-red-500" style={{ fontSize: '12px' }}>{r.FareList[0].SeatLeft} Seats Left</div> */}
                          </div>

                          <div className="flex-1 text-right">
                            <div className="text-2xl font-bold">{format(new Date(r.des.ToUTCTime), "HH:mm")}</div>
                            <div className="text-sm text-gray-600">{r.des.DeCity}</div>
                            <div className="text-xs text-gray-400 mt-2">{format(new Date(r.des.ToUTCTime), "EEE-ddMMMyyyy")}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Price & action */}
                    <div className="md:col-span-2 flex flex-col items-end justify-between gap-3">
                      <div className="w-full flex flex-col items-end gap-3">
                        <div className="text-right">
                          {/* <div className="text-sm line-through text-gray-400">₹ {r.originalPrice.toLocaleString()}</div> */}
                          <div className="text-lg font-bold"><CurFt currency={r.FareList[0].symbol} price={r.FareList[0].PublishedFare} /></div>
                          {/* <div className="text-sm text-green-600">Rs.{r.discount} Discount Applied</div> */}
                        </div>

                        <div className="flex flex-col w-full gap-2">
                          <button onClick={() => handleBookNow(r, r.FareList[0])} className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-lg shadow" >
                            Book Now
                          </button>

                          {/* <button className="text-sm font-medium text-[#1ea9e0] hover:underline">+ More Fare</button> */}
                        </div>
                      </div>

                      {/* Bottom Row */}

                    </div>
                  </div>
                  <div className="pb-2 pl-2 pr-2 flex items-center justify-between flex-wrap gap-2">
                    <div className="flex items-center gap-2 flex-wrap">
                      {/* Baggage */}
                      <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-white">
                        <BaggageClaim size={16} className="text-gray-700" />
                        <span className="text-gray-700">{r.FareList[0].Checkin}/{r.FareList[0].Cabin}</span>
                      </span>
                      {/* Seats Left */}
                      <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-blue-50 border-blue-200">
                        <Armchair size={16} className="text-blue-600" />
                        <span className="text-gray-700">
                          {r.FareList[0].SeatLeft} Seats Left
                        </span>
                      </span>

                      {r.FareList[0].IsRefundable ? (
                        <span className="inline-flex items-center text-sm bg-white">
                          <TicketCheck size={16} className={`${r.FareList[0].IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`} />
                          <span className={`${r.FareList[0].IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`}>
                            {r.FareList[0].RefundableTxt}
                          </span>
                        </span>
                      ) : (
                        <span className="inline-flex items-center text-sm bg-white">
                          <TicketX size={16} className="text-red-600" />
                          <span className="text-red-700">
                            {r.FareList[0].RefundableTxt}
                          </span>
                        </span>
                      )}

                      {/* Layover */}
                    </div>
                    {r.FareList.length > 1 && (
                      <button
                        onClick={() => toggleOpen(r.keyIndex)}
                        className="text-sm font-medium text-[#1ea9e0] hover:underline"
                      >
                        {openIndex === r.keyIndex
                          ? "Show Less"
                          : `+${r.FareList.length - 1} More fares`}
                      </button>
                    )}
                    {r.FareList[0].rewardEarns > 0 && (
                      <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-xs bg-white">
                        <img src="/coins.svg" className="w-5" />
                        <span className="text-orange-600">Earn Reward {r.FareList[0].rewardEarns}</span>
                      </span>
                    )}

                    <button onClick={() => handlFlightDeatils(r, r.FareList[0])} className="text-sm font-medium text-[#1ea9e0] hover:underline">
                      Flight Details
                    </button>
                  </div>


                  {openIndex === r.keyIndex && r.FareList.map((value, Farekey) => (
                    Farekey > 0 && (
                      <div
                        key={value.PriceID}
                        className={`grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 items-center gap-2 p-2 mt-2 border-t`}
                      >
                        {/* Left side (3 cols combined) */}
                        <div className="col-span-3 flex items-center gap-2 flex-wrap">
                          <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-blue-50 border-blue-200">
                            <Ticket size={16} className="text-blue-600" />
                            <span className="text-gray-700">
                              {value.fareIdentifier}
                            </span>
                          </span>
                          {value.SeatLeft > 0 && (
                            <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-blue-50 border-blue-200">
                              <Armchair size={16} className="text-blue-600" />
                              <span className="text-gray-700">
                                {value.SeatLeft} Seats Left
                              </span>
                            </span>
                          )}

                          {value.IsMeal ? (
                            <span className="inline-flex items-center gap-2 text-sm bg-white">
                              <Utensils size={16} className="text-green-600" />
                              <span className="text-green-600">Free Meal</span>
                            </span>
                          ) : (
                            <span className="inline-flex items-center gap-2 text-sm bg-white">
                              <Utensils size={16} className="text-red-600" />
                              <span className="text-red-600">Paid Meal</span>
                            </span>
                          )}

                          <span className="inline-flex items-center text-sm bg-white">
                            <BaggageClaim size={16} className="text-gray-600" />
                            <span className="text-gray-600">{value.Checkin}/{value.Cabin}</span>
                          </span>

                          {value.IsRefundable ? (
                            <span className="inline-flex items-center text-sm bg-white">
                              <TicketCheck size={16} className={`${value.IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`} />
                              <span className={`${value.IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`}>
                                {value.RefundableTxt}
                              </span>
                            </span>
                          ) : (
                            <span className="inline-flex items-center text-sm bg-white">
                              <TicketX size={16} className="text-red-600" />
                              <span className="text-red-600">
                                {value.RefundableTxt}
                              </span>
                            </span>
                          )}
                        </div>

                        {/* Price + Details (1 col) */}
                        <div className="text-right">
                          <button className="text-lg font-bold">
                            <CurFt
                              currency={value?.symbol || "INR"}
                              price={value.PublishedFare}
                            />
                          </button>
                          <br />
                          <span
                            onClick={() => handlFlightDeatils(r, value)}
                            className="text-sm font-medium text-[#1ea9e0] hover:underline cursor-pointer"
                          >
                            Details
                          </span>

                          {value.rewardEarns > 0 && (
                            <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-xs bg-white">
                              <img src="/coins.svg" className="w-5" />
                              <span className="text-orange-600">Earn Reward {value.rewardEarns}</span>
                            </span>
                          )}
                        </div>

                        {/* Book button (1 col) */}
                        <div className="text-right">
                          <button
                            onClick={() => handleBookNow(r, value)}
                            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-1 rounded-lg shadow"
                          >
                            Book
                          </button>
                        </div>
                      </div>
                    )
                  ))}
                </div>
              ))}
              {sorted.length == 0 && (
                <div
                  className="h-10 flex items-center justify-center text-gray-500 ssssss"
                >
                  No Flight Found
                </div>
              )}
            </div>
            <div className="h-12" />
          </div>
        </main>
      </div>
    </>
  );
}


function SortHead({ title, onClick, active, dir, className = "" }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-1 ${className}`}
      title={`Sort by ${title}`}
    >
      <span>{title}</span>
      <ArrowUpDown
        size={16}
        className={`${active ? "text-blue-600" : "text-gray-400"
          } ${dir === "desc" ? "rotate-180" : ""}`}
      />
    </button>
  );
}